import { Component, ViewEncapsulation } from '@angular/core';
import { DDatosCompartidosCabecera } from '@dian-cmp/formulario';


@Component({
  selector: 'app-contenedor-formulario',
  templateUrl: './contenedor-formulario.component.html',
  styleUrls: ['./contenedor-formulario.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ContenedorFormularioComponent {

  public dDatosCompartidosCabecera: DDatosCompartidosCabecera;
    
    constructor () {
    	this.dDatosCompartidosCabecera = new DDatosCompartidosCabecera();
    }

}



// WEBPACK FOOTER //
// D:/GIT/F300/V4/ng_formulario300v4/src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.ts